module.exports = __webpack_public_path__ + "img/works_starfield_e_btm.4eb5183a.jpg";